// removed by extract-text-webpack-plugin
module.exports = {"contact-notes-container":"contact-notes-container","Select--single":"Select--single","react-tabs__tab-list":"react-tabs__tab-list","contact-notes-header":"contact-notes-header","btn-primary":"btn-primary","quill":"quill","ql-container":"ql-container"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Docks/ContactInfo/ContactNotes/style.scss
// module id = sCQd
// module chunks = 0